<template>
    <div class="elltree">
        <el-tree
            :data="data"
            :highlight-current="true"
            :props="defaultProps"
            accordion
            @node-click="handleNodeClick"
            node-key="label"
            :default-expanded-keys="['甘肃省']"
        >
        </el-tree>
    </div>
</template>
<script>
import axios from 'axios'

export default {
    data() {
        return {
            data: [],
            defaultProps: {
                children: 'children',
                label: 'label',
            },
        }
    },
    mounted() {
        this.initData()
    },
    methods: {
        // 获取厅县数据
        initData() {
            let resData = [
                {
                    label: '甘肃省',
                    children: [],
                    level: 1,
                },
            ]
            let temp = {}
            axios({
                url: $webConfig.V3.backendAPI+"getCountyNew",
                method: 'get',
                params: {
                },
            }).then((res) => {
                res.data.data.forEach((feature) => {
                    let item = feature
                    let key = item[0]
                    if (!(key in temp)) {
                        temp[key] = {
                            label: key,
                            level: 2,
                            children: [
                                {
                                    label: item[1],
                                    level: 3,
                                },
                            ],
                        }
                    } else {
                        temp[key].children.push({
                            label: item[1],
                            level: 3,
                        })
                    }
                })
                for (let key in temp) {
                    resData[0].children.push(temp[key])
                }
                this.data = resData
            })
        },

        handleNodeClick(data) {
            this.$emit('changeCountry', data)
        },
    },
}
</script>
<style scoped>
.elltree
    >>> .el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content
    > .el-tree-node__label {
    /* background-color: #f0f7ff; */
    background: #12c287 !important;
    border: 5px solid #12c287;
}

.elltree
    >>> .el-tree-node__content{
        height: 32px;
    }
.elltree
    >>> .el-tree-node__label{
        font-size: 16px;
    }
</style>


// WEBPACK FOOTER //
// src/V3/Main/Home/comCountrySearch.vue